import { colors } from './colors'
export default {
    methods: {
        getColors(priority) {
            let newColors = []
            for (let i = 0; i < priority; i++) {
                newColors.push(colors[i])
            }
            return newColors
        }
    }
};

